<template>
	<router-link :to="{name: 'Event', params: { id: event.id }}" class="event">
		<div v-if="!event.photo" class="event__photo" style="background-image: url('/static/img/placeholder.jpg')"></div>
		<div v-if="event.photo" class="event__photo" :style="{ 'background-image': `url(${ event.photo })` }"></div>
		<div class="event__details-wrapper">
			<time class="event__details event__details--date">{{getDateRange(event.date, event.date_to)}}</time>
			<span class="event__details">{{event.city.name}} /</span>
			<span class="event__details event__details--marginBottom"><span class="event__details--uppercase">{{event.city.country.name}}</span><span v-if="event.distance !== null"> >> {{getDistance(event.distance)}}km</span></span>
			<span class="event__details event__details--name event__details--bigMarginBottom"
				  :class="`event__details--${event.rank}`">
				{{event.name}}
			</span>
			<span class="event__details--range"
				  :class="`event__details--${event.rank}`">
				{{event.rank}}
			</span>
		</div>
	</router-link>
</template>

<script>
	import { getDateRange, getYear } from '@/assets/js/date.js'

	export default {
		props: ['event'],
		methods: {
			getDateRange,
			getYear,
			getDistance (dist) {
				return Math.round(dist)
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../../styles/variables.scss";

	.event {
		display: block;
		background-color: #fff;
		margin: 0 12px;
		text-decoration: none;
		color: $black;
		&__photo {
			height: 215px;
			background-size: 100%;
			background-position: center;
			background-size: cover;
			background-repeat: no-repeat;
		}
		&__details-wrapper {
			display: flex;
			justify-content: space-between;
			flex-flow: column;
			padding: 15px;
		}
		&__details {
			text-align: left;
			display: block;
			font-size: 14px;
			line-height: 19px;
			&--marginBottom {
				margin-bottom: 10px;
			}
			&--bigMarginBottom {
				margin-bottom: 25px;
			}
			&--uppercase {
				text-transform: uppercase;
			}
			&--date {
				font-size: 20px;
				margin-bottom: 10px;
			}
			&--month {
				display: inline;
				text-transform: uppercase;
				font-family: $lato-bold;
				font-size: 15px;
				letter-spacing: 0.05em;
				margin-left: 10px;
			}
			&--name {
				min-height: 40px;
			}
			&--range {
				display: block;
				text-align: left;
				text-transform: uppercase;
				font-family: $lato-bold;
				font-size: 12px;
				line-height: 20px;
				letter-spacing: 0.05em;
			}
			&--national {
				color: $national;
			}
			&--international {
				color: $international;
			}
			&--club {
				color: $club;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Home/Event/EventTileComponent.vue